module.exports = __webpack_public_path__ + "img/新希望集团.c2387e77.png";